import { render, staticRenderFns } from "./tarifas_admin.vue?vue&type=template&id=14aa5e18&scoped=true&"
import script from "./tarifas_admin.vue?vue&type=script&lang=js&"
export * from "./tarifas_admin.vue?vue&type=script&lang=js&"
import style0 from "./tarifas_admin.vue?vue&type=style&index=0&id=14aa5e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa5e18",
  null
  
)

export default component.exports